var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"investor"}},[_c('AppHead'),_vm._v(" 投资者关系 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }